<div class="wrapper__form container mt-5 mb-3 border__form">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img src="../../../../assets/img/file-alt.svg" alt="logo" class="img-ico-form" />
      <h2 class="mb-0">
        {{ nombreCompleto }}
      </h2>
    </div>
  </div>
  <app-form
    [title]="'tramites.reorganizacion-ordinaria-insolvencia.tipo_solicitante' | translate"
    [fields]="campoTipoSolicitante"
    [withSubmitButton]="false"
    (changedControl)="validarTipo($event)">
  </app-form>
  <app-liq-judicial-sociedad *ngIf="mostrarSociedad"></app-liq-judicial-sociedad>
  <app-liq-judicial-pn-comerciante *ngIf="mostrarPNC"></app-liq-judicial-pn-comerciante>
  <app-liq-judicial-pn-no-comerciante *ngIf="mostrarPNNC"></app-liq-judicial-pn-no-comerciante>
  <app-liq-judicial-sucursal-extranjera *ngIf="mostrarSucursal"></app-liq-judicial-sucursal-extranjera>
</div>
